import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { removeFrom } from "@mapsight/core/lib/base/actions";
import { FEATURE_SELECTIONS } from "../../../config/constants/controllers";
import { FEATURE_SELECTION_SELECT } from "../../../config/feature/selections";
import { APP_EVENT_FOCUS_FEATURE_LIST, useAppChannelDispatchEvent, } from "../../helping/app-channel";
export function useKeyboardControl(enabled, ref, feature, options = {}) {
    const appChannelDispatchEvent = useAppChannelDispatchEvent();
    const dispatch = useDispatch();
    useEffect(() => {
        if (!enabled || !ref.current) {
            return undefined;
        }
        function handleEscape(ev) {
            if (ev.key === "Escape") {
                dispatch(removeFrom([
                    FEATURE_SELECTIONS,
                    FEATURE_SELECTION_SELECT,
                    "features",
                ], feature === null || feature === void 0 ? void 0 : feature.id));
                if (options.returnFocusToList) {
                    appChannelDispatchEvent(new Event(APP_EVENT_FOCUS_FEATURE_LIST));
                }
            }
        }
        const element = ref.current;
        element.addEventListener("keydown", handleEscape);
        return () => {
            element.removeEventListener("keydown", handleEscape);
        };
    }, [
        appChannelDispatchEvent,
        dispatch,
        enabled,
        feature === null || feature === void 0 ? void 0 : feature.id,
        options.returnFocusToList,
        ref,
    ]);
}
